import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { IconSearch } from "../../utils/icons";

interface Props {
  onSearchChange?: (text: string) => void;
}

export function SearchPanel({ onSearchChange }: Props) {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState("");

  const handleSearchChange = (val: ChangeEvent<HTMLInputElement>) => {
    if (timeoutId.current) clearTimeout(timeoutId.current);

    const { value } = val.target;
    setSearch(value);

    timeoutId.current = setTimeout(() => {
      if (onSearchChange) onSearchChange(value);
      else {
        setSearchParams((prev) => {
          prev.set("search", value);
          return prev;
        });
      }
    }, 300);
  };

  useEffect(() => {
    if (onSearchChange) return;

    const searchText = searchParams.get("search");
    if (!searchText) setSearch("");
  }, [searchParams, onSearchChange]);

  return (
    <Box
      className="min-w-[300px] px-3 flex items-center gap-2 bg-surface-2 h-[44px] rounded-lg text-sm"
      sx={{ fontFamily: "CircularStd" }}
    >
      <IconSearch />
      <input
        value={search}
        placeholder="Search"
        onChange={handleSearchChange}
        className="w-full text-text-1 h-full !bg-transparent hover:border-0 hover:shadow-0 hover:outline-none focus:!border-0 focus:!shadow-0 focus:!outline-none"
      />
    </Box>
  );
}
